import React from 'react'
import { useParams } from 'react-router-dom'

import ProductForm from '@components/catalog/product/ProductForm'


export default function CatalogProductPage () {
  const { productId, brandSlug } = useParams<any>()

  return (
    <div className="CatalogProductPage">
      <ProductForm brandSlug={brandSlug} productId={productId} />
    </div>
  )
}
